










import Vue from 'vue'

export default Vue.extend({
  name: 'BasePagePreloader',
  components: {},
  props: {
    showPreloader: {
      type: Boolean,
      default: true
    }
  }
})
